/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<g _fill="#979797"><path pid="0" d="M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zm0-2A7 7 0 1 0 9 2a7 7 0 0 0 0 14zM23.414 22L22 23.414 15.586 17 17 15.586z"/></g>`
  }
})
